import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import {
  getPlantillasNotificacion,
  createPlantillaNotificacion,
  editPlantillaNotificacion,
} from "../../Services/notificaciones_plantillas_service";

const initialState = {
  plantillas: [],
  plantilla: {
    idPlantilla: 0,
    nombre: "",
    tituloPlantilla: "",
    descripcionPlantilla: "",
    icono: "",
    estado: true,
    usuario: "",
  },
  plantillasSeleccionadas: [],
};

export const notificacionesPlantillasSlice = createSlice({
  name: "notificacionesPlantillas",
  initialState,
  reducers: {
    setPlantillas: (state, action) => {
      state.plantillas = action.payload;
    },
    setPlantilla: (state, action) => {
      state.plantilla = !action.payload
        ? initialState.plantilla
        : action.payload;
    },
    setPlantillasSeleccionadas: (state, action) => {
      state.plantillasSeleccionadas = action.payload;
    },
  },
});

export const fetchNotificacionesPlantillas = createAsyncThunk(
  "notificacionesPlantillas/fetchNotificacionesPlantillas",
  async (_, { dispatch }) => {
    const plantillasRes = await getPlantillasNotificacion();
    dispatch(setPlantillas(plantillasRes));
  }
);

export const addNotificacionPlantilla = createAsyncThunk(
  "notificacionesPlantillas/create",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const plantillaRes = await createPlantillaNotificacion(data);
    dispatch(setResponse(plantillaRes));
    dispatch(setLoading(false));
    dispatch(setModal(false));
    dispatch(setToast(true));
    dispatch(fetchNotificacionesPlantillas());
    setTimeout(() => {
      dispatch(setToast(false));
    }, 3000);
  }
);

export const EditNotificacionPlantilla = createAsyncThunk(
  "notificacionesPlantillas/update",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const plantillaRes = await editPlantillaNotificacion(data);
    dispatch(setResponse(plantillaRes));
    dispatch(setLoading(false));
    dispatch(setModal(false));
    dispatch(setToast(true));
    dispatch(fetchNotificacionesPlantillas());
    setTimeout(() => {
      dispatch(setToast(false));
    }, 3000);
  }
);

export const { setPlantillas, setPlantilla, setPlantillasSeleccionadas } =
  notificacionesPlantillasSlice.actions;
export default notificacionesPlantillasSlice.reducer;
